export default function PromptBuilderEmptyStateIcon({
  width = 150,
  height = 110
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg width={width} height={height} viewBox='0 0 250 149' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M136 39C139.866 39 143 42.134 143 46C143 49.866 139.866 53 136 53H200C203.866 53 207 56.134 207 60C207 63.866 203.866 67 200 67H222C225.866 67 229 70.134 229 74C229 77.866 225.866 81 222 81H203C199.134 81 196 84.134 196 88C196 91.866 199.134 95 203 95H209C212.866 95 216 98.134 216 102C216 105.866 212.866 109 209 109H157C156.485 109 155.983 108.944 155.5 108.839C155.017 108.944 154.515 109 154 109H63C59.134 109 56 105.866 56 102C56 98.134 59.134 95 63 95H24C20.134 95 17 91.866 17 88C17 84.134 20.134 81 24 81H64C67.866 81 71 77.866 71 74C71 70.134 67.866 67 64 67H39C35.134 67 32 63.866 32 60C32 56.134 35.134 53 39 53H79C75.134 53 72 49.866 72 46C72 42.134 75.134 39 79 39H136ZM226 95C229.866 95 233 98.134 233 102C233 105.866 229.866 109 226 109C222.134 109 219 105.866 219 102C219 98.134 222.134 95 226 95Z'
        fill='#FAFAFA'
      />
      <path
        d='M120.5 108C139.002 108 154 93.0015 154 74.5C154 55.9985 139.002 41 120.5 41C101.998 41 87 55.9985 87 74.5C87 93.0015 101.998 108 120.5 108Z'
        fill='#FAFAFA'
        stroke='#777777'
        stroke-width='2.5'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M115.132 100.494C116.891 100.819 118.68 100.987 120.5 101C135.136 101 147 89.1355 147 74.5C147 59.8645 135.136 48 120.5 48C116.74 48 113.164 48.7829 109.924 50.1946C104.294 52.6479 99.6816 56.9999 96.896 62.4419C95.0445 66.0589 94 70.1575 94 74.5C94 78.44 94.8599 82.1792 96.4021 85.5401C97.5032 87.9396 98.9521 90.1463 100.684 92.0956'
        fill='white'
      />
      <path
        d='M115.132 100.494C116.891 100.819 118.68 100.987 120.5 101C135.136 101 147 89.1355 147 74.5C147 59.8645 135.136 48 120.5 48C116.74 48 113.164 48.7829 109.924 50.1946C104.294 52.6479 99.6816 56.9999 96.896 62.4419C95.0445 66.0589 94 70.1575 94 74.5C94 78.44 94.8599 82.1792 96.4021 85.5401C97.5032 87.9396 98.9521 90.1463 100.684 92.0956'
        stroke='#777777'
        stroke-width='2.5'
        stroke-linecap='round'
      />
      <path
        d='M103.797 95.0742C105.945 96.8202 108.372 98.2365 111 99.2461'
        stroke='#777777'
        stroke-width='2.5'
        stroke-linecap='round'
      />
      <path d='M148 101L154 107' stroke='#777777' stroke-width='2.5' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M153.029 106.029C151.136 107.922 151.136 110.99 153.029 112.883L164.114 123.968C166.007 125.861 169.076 125.861 170.968 123.968C172.861 122.076 172.861 119.007 170.968 117.114L159.883 106.029C157.99 104.136 154.922 104.136 153.029 106.029Z'
        fill='#F8F9FA'
        stroke='#777777'
        stroke-width='2.5'
      />
      <path d='M158 108L169 119' stroke='white' stroke-width='2.5' stroke-linecap='round' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M113.997 63.0005C113.997 74.5985 123.399 84.0005 134.997 84.0005C137.275 84.0005 139.469 83.6377 141.523 82.9667C138.17 91.2876 130.019 97.1612 120.497 97.1612C107.981 97.1612 97.8359 87.0157 97.8359 74.5005C97.8359 63.1601 106.166 53.7653 117.042 52.1016C115.11 55.2798 113.997 59.0102 113.997 63.0005Z'
        fill='#F8F9FA'
      />
      <path
        d='M121 56C119.727 56 118.482 56.1253 117.279 56.3642M113.645 57.4761C106.804 60.3508 102 67.1144 102 75'
        stroke='#ECECEC'
        stroke-width='2.5'
        stroke-linecap='round'
      />
      <path
        d='M174.18 74.7773H166.004M180.504 67H163.328H180.504ZM187.504 67H185.283H187.504Z'
        stroke='#ECECEC'
        stroke-width='2.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M84.1782 96.7773H76.0024M79.5024 88H62.3267H79.5024ZM56.5024 88H52.2812H56.5024Z'
        stroke='#ECECEC'
        stroke-width='2.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
